/**
 * Normalizes the GET /rewards/dashboard payload to the RewardsContent shape.
 * This runs ONLY for a real, logged-in 200 payload (the mock/preview path is
 * handled separately via getRewardsMockState). Every field therefore falls back
 * to a genuine EMPTY / no-tier value — never to fabricated mock numbers — so a
 * partial live payload can render an honest empty state instead of fake data.
 */

export function normalizeRewardsDashboard(payload) {
  const data = payload && typeof payload === "object" ? payload : {};
  const vip = data.vip && typeof data.vip === "object" ? data.vip : {};
  const balances =
    data.balances && typeof data.balances === "object" ? data.balances : {};
  const cloverCoins =
    balances.cloverCoins && typeof balances.cloverCoins === "object"
      ? balances.cloverCoins
      : {};
  const freeSpins =
    balances.freeSpins && typeof balances.freeSpins === "object"
      ? balances.freeSpins
      : {};
  const streak =
    data.streak && typeof data.streak === "object" ? data.streak : {};
  const badges = Array.isArray(data.badges) ? data.badges : [];

  return {
    ...data,
    vip: {
      ...vip,
      // No fabricated tier: an absent VIP object yields a neutral "no tier"
      // state the renderer can present honestly, not a fake SILVER CLOVER.
      tierKey: vip.tierKey || "",
      tierName: vip.tierName || "",
      progressPct: Number.isFinite(Number(vip.progressPct))
        ? Number(vip.progressPct)
        : 0,
      ptsLabel: vip.ptsLabel || "",
      nextTierName: vip.nextTierName || "",
      toNextLabel: vip.toNextLabel || "",
    },
    balances: {
      ...balances,
      cloverCoins: {
        ...cloverCoins,
        amount: cloverCoins.amount ?? "0",
        weekDelta: cloverCoins.weekDelta ?? "",
      },
      freeSpins: {
        ...freeSpins,
        amount: freeSpins.amount ?? "0",
        meta: freeSpins.meta ?? "",
      },
      bonuses: Array.isArray(balances.bonuses) ? balances.bonuses : [],
    },
    streak: {
      ...streak,
      days: streak.days ?? 0,
      dayPills: Array.isArray(streak.dayPills) ? streak.dayPills : [],
      todayReward: streak.todayReward ?? "",
    },
    badges,
    activity: Array.isArray(data.activity) ? data.activity : [],
    earnedCount: data.earnedCount ?? badges.filter((b) => b && !b.locked).length,
    totalBadges: data.totalBadges ?? badges.length,
  };
}
